export enum AppConfigKey {
	GrayScreenFilter = 'setting.gray_screen_filter',
}
